// store/modules/user.js

import apiClient from "@/axios";
import { message } from 'ant-design-vue';

const state = {
  territories: [],
  notifications:[],
  total:{
    totalNotifications:'',
    totalReadNotifications:''
  }
};

const getters = {
  getterritories: (state) => state.territories,
  getNotifications: (state) => state.notifications,
  getTotalNotifications : (state) => state.total
};


const mutations = {
  SET_TERRITORIES(state, territories) {
    state.territories = territories;
  },
  SET_NOTIFICATIONS(state, data) {
    if(data.length === 0){
      state.notifications = []
      return
    }

    if(data.current_page === 1){
      state.notifications = data.data
    } else{
      state.notifications = [...state.notifications, ...data.data]
    }

  },
  SET_TOTAL_NOTIFICATIONS(state, data) {
    state.total = {
          totalNotifications: data?.total || state.total.totalNotifications,
          totalReadNotifications:data?.unread_count || null
    }
  },
};

const actions = {
  async fetchTerritories({ commit }) {
    try {
      const response = await apiClient.get('/dropdown/territories');

      commit('SET_TERRITORIES', response.data);
      return response.data
    } catch (error) {
      console.error('Error fetching territories:', error);
    }
  },
  async fetchCompanyPermissions({ commit }) {
    try {
      const response = await apiClient.get('/settings/permissions-list');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching company permissions:', error);
    }
  },
  async fetchUserPermissions({ commit }) {
    try {
      const response = await apiClient.get('/settings/assigned-permissions');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching user permissions:', error);
    }
  },
  async fetchUsers({ commit }, params){
    try {
      const response = await apiClient.get('/company/users', { params });
      return response;
    } catch (error) {
      console.error('Error fetching users data:', error);
    }
  },
  async createCompanyAdmin({ commit }, form) {
    try {
      const formData = new FormData();
    
      // Append all fields to FormData
      Object.keys(form).forEach(key => {
        const value = form[key];
    
        if (key === 'admin_user' && typeof value === 'object') {
          // Handle the nested admin_user object
          Object.keys(value).forEach(innerKey => {
            const innerValue = value[innerKey];
            formData.append(`admin_user[${innerKey}]`, innerValue);
          });
        } else if (Array.isArray(value)) {
          // Handle arrays
          if (value.length > 0) {
            value.forEach((item, index) => {
              formData.append(`${key}[${index}]`, item);
            });
          } else {
            formData.append(key, ''); // Send empty array
          }
        } else if (value !== null) {
          // Only append non-null values
          formData.append(key, value);
        }
      });
    
      // Handle image for updates
      if (form.id && typeof form.company_logo === 'string') {
        formData.set('company_logo', '');
      }
    
      // API request
      const endpoint = form.id
        ? `/admin/update-company-admin/${form.id}`
        : '/admin/create-company-admin';
    
      const response = await apiClient.post(endpoint, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    
      return response;
    } catch (error) {
      console.error('Error saving user data:', error);
      return {
        status: false,
        errors: error.response?.data?.errors || 'Unknown error',
      };
    }
  },

  async createUser({ commit }, form) {
    try {
      const formData = new FormData();
  
      // Append all fields to FormData
      Object.keys(form).forEach(key => {
        const value = form[key];
  
        if (Array.isArray(value)) {
          // Handle arrays
          if (value.length > 0) {
            if(key === 'roles_data'){
                  // Loop for roles_data
                  form.roles_data.forEach((roleData, index) => {
                  formData.append(`roles_data[${index}][role]`, roleData.role);
                  roleData.territory_ids.forEach((territoryId, tIndex) => {
                    formData.append(`roles_data[${index}][territory_ids][${tIndex}]`, territoryId);
                  });
                  formData.append(`roles_data[${index}][assigned_manager]`, roleData.assigned_manager);
                });
            } else{
              value.forEach((item, index) => {
                formData.append(`${key}[${index}]`, item);
              });
            }
          } else {
            formData.append(key, ''); // Send empty array
          }
        } else if (value !== null) {
          // Only append non-null values
          formData.append(key, value);
        }
      });

      // Handle image for updates
      if (form.id && typeof form.image === "string") {
        formData.set('image', "");
      }
      // API request
      const endpoint = form.id
        ? `/company/users/update/${form.id}`
        : '/company/user/register';
  
      const response = await apiClient.post(endpoint, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return response;
    } catch (error) {
      if(error.response.data.message){
        return {
          status: false,
          errors: error.response?.data || 'Unknown error',
        };
      }else{
        return {
          status: 500,
          errors: error.response?.data || 'Unknown error',
        };
      }
    }
  },
  async getUserFilterData({ commit },{ responsibles, type }) {
    try {
      const response = await apiClient.post(`/save/lisitingSettings`, {
        responsibles, type
      } );
      return response.data;
    } catch (error) {
      return {
        status: false,
        errors: error.response?.data?.errors || 'Unknown error',
      };
    }
  },
  async getUsersFilters({ commit }, type ){
    try {
      // API request
        const getlist = await apiClient.get(`/getLisitngSettings/${type}`);
      return getlist.data;
    } catch (error) {
      return {
        status: false,
        errors: error.response?.data?.errors || 'Unknown error',
      };
    }
  },
  async createPipeline({ commit }, form) {
    try {
      // API request
      const endpoint = form.id
        ? `/pipeline-level/update/${form.id}`
        : '/pipeline-level/create';
  
      const response = await apiClient.post(endpoint, form);
      return response;
    } catch (error) {
      console.error('Error saving user data:', error);
      return {
        status: false,
        errors: error.response?.data?.errors || 'Unknown error',
      };
    }
  },
  async getCompanyAdmins({ commit }, params) {
    try {
      const response = await apiClient.get('/admin/company-admins', { params });
      return response.data;
    } catch (error) {
      console.error('Error saving company data:', error);
    }
  },
  async getCompanyData({ commit }, id) {
    try {
      const response = await apiClient.get(`/admin/view-company-admin/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error saving organization data:', error);
    }
  },
  async changeCompanyStatus({ commit }, params) {
    try {
      const response = await apiClient.post(
        `/admin/activate-deactivate/${params.id}`,
        {
          status: params.text
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error saving organization data:', error);
      // return { status: false, errors: error.response.data.errors };
    }
  },
  async createSupplier({ commit }, form) {
    try {
      // API request
      const endpoint = form.id
        ? `/suppliers/update/${form.id}`
        : 'suppliers/create';
  
      const response = await apiClient.post(endpoint, form);
      return response;
    } catch (error) {
      console.error('Error saving Supplier data:', error);
      return {
        status: false,
        errors: error.response?.data?.errors || 'Unknown error',
      };
    }
  },

  async fetchApiNames({ commit }) {
    try {
      const response = await apiClient.get('/settings/api-clicks');
      return response.data;
    } catch (error) {
      console.error('Error fetching company permissions:', error);
    }
  },
  async fetchNotifications({ commit }, params) {
    try {
      const response = await apiClient.get('/notifications',{
        params:params
      });

      commit('SET_NOTIFICATIONS', response.data.data);
      commit('SET_TOTAL_NOTIFICATIONS', response.data.data);
      return response.data.data
    } catch (error) {
      console.error('Error fetching territories:', error);
    }
  },
  async markReadNotifications({commit}) {
    try {
      const response = await apiClient.get('/notifications/mark-all-read');
      commit('SET_TOTAL_NOTIFICATIONS', response.data);
      return response.data.data
    } catch (error) {
      console.error('Error fetching territories:', error);
    }
  },

  async importPowerApiPayload({commit}, companyId) {
    try {
      const response = await apiClient.get(`/admin/import-price-exchange/${companyId}`);
      message.success(response.data.message);
      return response.data;
    } catch (error) {
      message.error(error.response.data.message || 'Error running the import');
      console.error('Error fetching territories:', error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
